import { RECTORIUM_NAME } from '../constants/brand';

export const DEFAULT_TENANT = {
  id: null,
  slug: 'rectorium-demo',
  name: 'Rectorium Demo Academy',
  short_name: 'Rectorium',
  tagline: 'Excellence Académique · Innovation · Impact',
  // Aucun repli géographique (règle « application monde », 2026-10-27) : pays,
  // ville, fuseau et description d'un établissement sont ceux de SON tenant, lus
  // en base. Un repli vide reste vide ; un lieu inventé s'affichait pour tout
  // établissement dont la colonne manquait (anonyme, lecture échouée).
  description: '',
  logo_url: null,
  logo_dark_url: null,
  favicon_url: null,
  cover_url: null,
  primary_color: 'var(--color-primary)',
  secondary_color: 'var(--accent2)',
  surface_color: '#1e1e2e',
  surface2_color: '#27273a',
  text_color: 'var(--border)',
  font_family: 'Inter',
  address: '',
  city: '',
  country: '',
  phone: '',
  email: '',
  website: '',
  grading_system: {
    max: 20, pass: 10, distinction: 14, unit: 'points', cc_weight: 0.4, sn_weight: 0.6,
    // M7 §5.2 — la réclamation sur une note. Défauts D'USAGE, pas décisions :
    // chaque établissement les règle depuis ses paramètres. Rien en dur
    // ailleurs, sans quoi un délai changé ici ne changerait rien à l'écran.
    delai_reclamation_jours_ouvres: 8,
    ecart_seconde_correction_max: 2,
  },
  credit_system: { semester: 30, year: 60, pass_threshold: 0.70 },
  attendance_threshold: 75,
  governance_config: {
    rbac_mode: 'legacy',
  },
  matricule_prefix: 'REC',
  // Les QUATORZE codes métier de `public.modules_catalog`, dans l'ordre du
  // DEFAUT de `tenants.enabled_modules` (`20260825100000`). Ce repli portait
  // jusqu'au 2026-09-08 une liste de vingt valeurs dont SEIZE n'existaient
  // dans aucun référentiel — teachers, grades, schedule, payments, pilotage,
  // certifications, storage, lms, virtual, forum, messaging, budget,
  // internships, ai, ldmp, documents. Un repli n'invente pas : il annonce ce
  // que la base rendra. (Chantier `enabled-modules-quatre-vocabulaires`.)
  enabled_modules: [
    'governance','admissions','academic','students','hr','teaching','exams',
    'operations','quality','research','finance','alumni','campus','pmo',
  ],
  document_settings: {},
  default_language: 'fr',
  timezone: '',
  // Purge données factices (2026-07-12) : plus JAMAIS une licence inventée en
  // repli — « ENTREPRISE, 50 jours restants » s'affichait comme donnée réelle.
  // free sans échéance = état neutre honnête tant que la base n'a pas répondu.
  license_type: 'free',
  license_start: null,
  license_end: null,
  max_students: 5000,
  max_teachers: 500,
  max_campuses: 10,
  max_schools: 20,
  max_users: 1000,
  max_storage_gb: 50,
  is_active: true,
};

export const GLOBAL_PLATFORM_CONTEXT = {
  id: null,
  slug: 'global',
  name: 'Rectorium',
  short_name: 'Rectorium',
  tagline: 'Master Platform',
  description: 'Administration globale de la plateforme multi-tenant Rectorium.',
  logo_url: null,
  logo_dark_url: null,
  favicon_url: null,
  cover_url: null,
  primary_color: 'var(--purple)',
  secondary_color: 'var(--color-success)',
  surface_color: '#1e1e2e',
  surface2_color: '#27273a',
  text_color: 'var(--border)',
  font_family: 'Inter',
  address: '',
  // Rectorium OS est une marque de Rectorium Corporation (État du Delaware, États-Unis) : le
  // contexte plateforme n'est le tenant d'aucun pays. Ville, pays et fuseau de la plateforme
  // se posent en base (tenant `global`), jamais ici.
  city: '',
  country: '',
  phone: '',
  email: '',
  website: '',
  grading_system: {
    max: 20, pass: 10, distinction: 14, unit: 'points', cc_weight: 0.4, sn_weight: 0.6,
    // M7 §5.2 — la réclamation sur une note. Défauts D'USAGE, pas décisions :
    // chaque établissement les règle depuis ses paramètres. Rien en dur
    // ailleurs, sans quoi un délai changé ici ne changerait rien à l'écran.
    delai_reclamation_jours_ouvres: 8,
    ecart_seconde_correction_max: 2,
  },
  credit_system: { semester: 30, year: 60, pass_threshold: 0.70 },
  attendance_threshold: 75,
  governance_config: {
    rbac_mode: 'legacy',
  },
  matricule_prefix: 'RECTORIUM',
  // Mêmes quatorze codes que le repli générique, et pour la même raison : ce
  // que la base rend, jamais un vocabulaire inventé.
  enabled_modules: [
    'governance','admissions','academic','students','hr','teaching','exams',
    'operations','quality','research','finance','alumni','campus','pmo',
  ],
  document_settings: {},
  default_language: 'fr',
  timezone: '',
  // Le tenant plateforme n'est pas un client : aucune licence commerciale,
  // aucune échéance (purge données factices 2026-07-12).
  license_type: 'free',
  license_start: null,
  license_end: null,
  max_students: 999999,
  max_teachers: 99999,
  max_campuses: 999,
  max_schools: 999,
  max_users: 9999,
  max_storage_gb: 10000,
  is_active: true,
};

export const applyTenantTheme = (tenant) => {
  const r = document.documentElement;
  if (tenant?.primary_color)   r.style.setProperty('--accent',   tenant.primary_color);
  if (tenant?.secondary_color) r.style.setProperty('--accent2',  tenant.secondary_color);

  if (tenant?.favicon_url) {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) { link = document.createElement('link'); link.rel = 'icon'; document.head.appendChild(link); }
    link.href = tenant.favicon_url;
  }

  const sn = tenant?.short_name || tenant?.name || RECTORIUM_NAME;
  document.title = `${sn} — ${RECTORIUM_NAME}`;
};
